import _mergeJSXProps5 from "@vue/babel-helper-vue-jsx-merge-props";
import _mergeJSXProps4 from "@vue/babel-helper-vue-jsx-merge-props";
import _mergeJSXProps3 from "@vue/babel-helper-vue-jsx-merge-props";
import _mergeJSXProps2 from "@vue/babel-helper-vue-jsx-merge-props";
import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import omit from 'object.omit';
import VMenu, { VMenuItem, VMenuItemGroup } from '@cloud-sn/v-menu';
import Trigger from '@cloud-sn/v-trigger';
import { isArray, isFunction, isEqual, isPlainObject, updatePortalElement, cloneDeepWith } from '@cloud-sn/v-utils';
import VirtualList from '../virtual-list';
import { buildComponentName } from '../utils';
import { isValidValue, buildOptionsFromSlot, cloneLabelNodes, isOptionGroup, buildOptionOriginNode, getOptionLabelMap, splitValueBySeparator, getComboboxValue, getOptionOriginNode, isUnRenderOption } from './utils';
import placements from './placements';
import PlaceholderMixin from './mixins/placeholder';
import SingleMixin from './mixins/single';
import MultipleMixin from './mixins/multiple';
import SearchMixin from './mixins/search';
import TagsMixin from './mixins/tags';
var defaultLazy = {
  remain: 8,
  height: 32
};
export default {
  name: buildComponentName('Select'),
  mixins: [PlaceholderMixin, SingleMixin, MultipleMixin, SearchMixin, TagsMixin],
  provide: function provide() {
    return {
      selectNRoot: this
    };
  },
  props: {
    prefixCls: {
      type: String,
      default: 'ux-select'
    },
    dataSource: {
      type: Array,
      default: null
    },
    value: {
      type: [String, Number, Array],
      default: null
    },
    visible: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      validator: function validator(val) {
        return ['multiple', 'tags', 'default', 'SECRET_COMBOBOX_MODE_DO_NOT_USE'].indexOf(val) > -1;
      },
      default: 'default'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    allowClear: {
      type: Boolean,
      default: false
    },
    autoClearSearchValue: {
      type: Boolean,
      default: true
    },
    showSearch: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Please Select'
    },
    showArrow: {
      type: Boolean,
      default: true
    },
    popupClass: {
      type: [String, Object, Array],
      default: ''
    },
    popupStyle: {
      type: Object,
      default: null
    },
    builtinPlacements: {
      type: Object,
      default: function _default() {
        return placements;
      }
    },
    transition: {
      type: String,
      default: 'slide-up'
    },
    dropdownMatchSelectWidth: {
      type: Boolean,
      default: true
    },
    dropdownMenuStyle: {
      type: Object,
      default: undefined
    },
    getContainer: {
      type: Function,
      default: null
    },
    filterOption: {
      type: [Function, Boolean],
      default: null
    },
    renderLabel: {
      type: Function,
      default: null
    },
    renderGroupLabel: {
      type: Function,
      default: null
    },
    lazy: {
      type: [Object, Boolean],
      default: true
    },
    size: {
      type: String,
      default: '',
      validator: function validator(val) {
        return ['large', 'default', 'small', ''].indexOf(val) > -1;
      }
    },
    maxTagCount: {
      type: [Number, String],
      default: -1
    },
    maxTagPlaceholder: {
      type: [String, Function],
      default: null
    },
    maxTagTextLength: {
      type: [Number, String],
      default: null
    },
    optionFilterProp: {
      type: String,
      default: 'value',
      validator: function validator(val) {
        return ['label', 'value'].indexOf(val) > -1;
      }
    },
    optionLabelProp: {
      type: String,
      default: undefined,
      validator: function validator(val) {
        return ['value', 'label', 'children'].indexOf(val) > -1;
      }
    },
    notFoundContent: {
      type: [String, Object],
      default: undefined
    },
    clearDisabled: {
      type: Boolean,
      default: true
    },
    choiceTranstion: {
      type: String,
      default: 'zoom'
    },
    tokenSeparatorProp: {
      type: String,
      default: 'label',
      validator: function validator(val) {
        return ['label', 'value'].indexOf(val) > -1;
      }
    },
    tokenSeparators: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    getInputElement: {
      type: Function,
      default: null
    },
    control: {
      type: Boolean,
      default: false
    },
    extraTopContent: {
      type: Function,
      default: null
    },
    extraBottomContent: {
      type: Function,
      default: null
    },
    renderSelectionInput: {
      type: Function,
      default: null
    }
  },
  data: function data() {
    return {
      innerValue: null,
      innerVisible: false,
      searchInputValue: '',
      isMounted: false
    };
  },
  computed: {
    nLazy: function nLazy() {
      var lazy = this.lazy;

      if (lazy === false) {
        return false;
      }

      if (isPlainObject(lazy)) {
        return _objectSpread({}, defaultLazy, {}, lazy);
      }

      return defaultLazy;
    },
    isTags: function isTags() {
      return this.mode === 'tags';
    },
    isMultipleOrTags: function isMultipleOrTags() {
      var mode = this.mode;
      return mode === 'tags' || mode === 'multiple';
    },
    isCombobox: function isCombobox() {
      return this.mode === 'SECRET_COMBOBOX_MODE_DO_NOT_USE';
    },
    isMultipleOrTagsOrCombobox: function isMultipleOrTagsOrCombobox() {
      var isCombobox = this.isCombobox,
          isMultipleOrTags = this.isMultipleOrTags;
      return isMultipleOrTags || isCombobox;
    },
    popupClasses: function popupClasses() {
      var prefixCls = this.prefixCls,
          isMultipleOrTags = this.isMultipleOrTags;
      return _defineProperty({}, "".concat(prefixCls, "-dropdown--").concat(isMultipleOrTags ? 'multiple' : 'single'), true);
    },
    normalizeNotFountContent: function normalizeNotFountContent() {
      var notFoundContent = this.notFoundContent,
          isCombobox = this.isCombobox;

      if (notFoundContent !== undefined) {
        return notFoundContent;
      }

      if (isCombobox) {
        return null;
      }

      return 'Not Found';
    },
    normalizeOptionLabelProp: function normalizeOptionLabelProp() {
      var optionLabelProp = this.optionLabelProp,
          isCombobox = this.isCombobox;
      var labelProp = optionLabelProp;

      if (isCombobox && (!labelProp || labelProp === 'children')) {
        labelProp = 'value';
      }

      return labelProp;
    }
  },
  watch: {
    value: function value(nVal) {
      this.setInnerValue(nVal, false, true);
      this.updateComboxInputValue();
    },
    visible: function visible(nVal) {
      this.setInnerVisible(nVal, false);
    }
  },
  created: function created() {
    var value = this.value,
        visible = this.visible,
        setInnerValue = this.setInnerValue,
        setInnerVisible = this.setInnerVisible;
    setInnerValue(value, false, true);
    setInnerVisible(visible, false); // no reactive data

    this.optionMap = {};
    this.prevSelections = null;
    this.prevInnerVisible = undefined;
    this.selectedOffset = 0;
    this.selectedPos = null;
    this.rootLineMapping = null;
    this.isVirtualInit = false;
    this.innerValueObj = {}; // no reactive data
  },
  mounted: function mounted() {
    this.isMounted = true;
    this.updateComboxInputValue();
  },
  updated: function updated() {
    var _this = this;

    var _this$$refs = this.$refs,
        triggerRef = _this$$refs.triggerRef,
        virtualListRef = _this$$refs.virtualListRef,
        menuRef = _this$$refs.menuRef,
        prevInnerVisible = this.prevInnerVisible,
        innerVisible = this.innerVisible,
        nLazy = this.nLazy;

    if (prevInnerVisible !== innerVisible) {
      this.prevInnerVisible = innerVisible;

      if (innerVisible) {
        if (triggerRef) {
          var alignElement = triggerRef.getPortalPopupElement();
          updatePortalElement(alignElement, function () {
            var line = _this.selectedPos.line;

            if (nLazy) {
              if (virtualListRef) {
                if (line > 0) {
                  virtualListRef.setScrollTop((line - 1) * nLazy.height);
                }
              }
            } else if (menuRef) {
              menuRef.$el.scrollTop = (line - 1) * defaultLazy.height;
            }
          });
        }
      }
    }
  },
  methods: {
    updateComboxInputValue: function updateComboxInputValue() {
      var isCombobox = this.isCombobox,
          setSearchInputValue = this.setSearchInputValue,
          innerValue = this.innerValue,
          optionMap = this.optionMap,
          normalizeOptionLabelProp = this.normalizeOptionLabelProp;

      if (isCombobox) {
        setSearchInputValue(getComboboxValue(innerValue, optionMap, normalizeOptionLabelProp), false, false);
      }
    },
    maybeFocus: function maybeFocus() {
      var isMultipleOrTagsOrCombobox = this.isMultipleOrTagsOrCombobox,
          multipleSearchInputFocus = this.multipleSearchInputFocus,
          singleSearchInputFocus = this.singleSearchInputFocus;
      setTimeout(function () {
        (isMultipleOrTagsOrCombobox ? multipleSearchInputFocus : singleSearchInputFocus)();
      }, 0);
    },
    forceUpdateTriggerAlign: function forceUpdateTriggerAlign() {
      var triggerRef = this.$refs.triggerRef,
          innerVisible = this.innerVisible;

      if (triggerRef && innerVisible) {
        this.$nextTick(function () {
          triggerRef.forcePopupAlign();
        });
      }
    },
    setInnerValue: function setInnerValue(value) {
      var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var isPass = arguments.length > 2 ? arguments[2] : undefined;
      var innerValue = this.innerValue,
          isMultipleOrTags = this.isMultipleOrTags,
          optionMap = this.optionMap,
          control = this.control;
      var pass = isPass || !control;
      var val = isValidValue(value) ? value : [];
      val = isArray(val) ? val : [val];

      if (!isMultipleOrTags) {
        val = isValidValue(val[0]) ? [val[0]] : [];
      }

      if (!isEqual(val, innerValue)) {
        if (pass) {
          this.innerValue = val;
        }

        if (trigger) {
          var nVal = _toConsumableArray(val);

          nVal = isMultipleOrTags ? nVal : nVal[0];
          var valObj = isMultipleOrTags ? nVal.map(function (v) {
            return buildOptionOriginNode(v, optionMap);
          }) : buildOptionOriginNode(nVal, optionMap);

          if (pass) {
            this.$emit('input', nVal, valObj);
          } // 兼容原有Select行为Function(Object, value)


          this.$emit('change', valObj, nVal);
        }
      }
    },
    setInnerVisible: function setInnerVisible(visible) {
      var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this.innerVisible = visible;

      if (trigger) {
        this.$emit('popup-visible-change', visible);
      }
    },
    // optionMap是非响应式属性(optionMap设为响应式时,可能造成无限循环),为防止optionMap更新后无法获取最新的值, 因此作为方法使用
    getSelectionValue: function getSelectionValue() {
      var optionMap = this.optionMap,
          innerValue = this.innerValue,
          innerValueObj = this.innerValueObj;
      var values = [];

      for (var i = 0, l = innerValue.length; i < l; i += 1) {
        var key = innerValue[i];

        if (key in optionMap) {
          values.push(optionMap[key]);
        } else if (key in innerValueObj) {
          values.push(innerValueObj[key]);
        } else {
          var option = {
            value: key,
            label: key,
            content: key,
            selectionContent: key
          };
          option.originNode = {
            value: key,
            label: key
          };
          values.push(option);
        }
      }

      return values;
    },
    getPopupWidth: function getPopupWidth() {
      var $el = this.$el,
          getPopupWidth = this.getPopupWidth,
          dropdownMatchSelectWidth = this.dropdownMatchSelectWidth,
          innerVisible = this.innerVisible;
      var style;

      if (innerVisible) {
        style = _defineProperty({}, dropdownMatchSelectWidth ? 'width' : 'minWidth', "".concat($el.offsetWidth, "px"));
        getPopupWidth.prev = style;
      } else {
        style = getPopupWidth.prev;
      }

      return style;
    },
    onPopupVisibleChange: function onPopupVisibleChange(visible) {
      var setInnerVisible = this.setInnerVisible,
          onSelectorBlur = this.onSelectorBlur,
          isCombobox = this.isCombobox;
      setInnerVisible(visible);

      if (!visible && !isCombobox) {
        setTimeout(function () {
          onSelectorBlur();
        }, 100);
      }
    },
    onMenuSelect: function onMenuSelect(_ref2) {
      var name = _ref2.name;
      var isCombobox = this.isCombobox,
          normalizeOptionLabelProp = this.normalizeOptionLabelProp,
          isMultipleOrTags = this.isMultipleOrTags,
          innerValue = this.innerValue,
          setInnerVisible = this.setInnerVisible,
          setInnerValue = this.setInnerValue,
          optionMap = this.optionMap,
          maybeFocus = this.maybeFocus,
          setSearchInputValue = this.setSearchInputValue,
          autoClearSearchValue = this.autoClearSearchValue,
          clearSearchInputValue = this.clearSearchInputValue,
          disabled = this.disabled;

      if (disabled) {
        return;
      }

      var values = _toConsumableArray(innerValue);

      if (isMultipleOrTags) {
        if (values.indexOf(name) === -1) {
          values.push(name);
        }
      } else {
        values = [name];
        setInnerVisible(false);
      }

      setInnerValue(values);
      this.$emit('select', name, buildOptionOriginNode(name, optionMap));

      if (isCombobox) {
        var inputValue = getComboboxValue(name, optionMap, normalizeOptionLabelProp);
        setSearchInputValue(inputValue, false, false);
      } else if (autoClearSearchValue) {
        setTimeout(function () {
          clearSearchInputValue(false);
        }, 100);
      }

      maybeFocus();
    },
    removeSelected: function removeSelected(name) {
      var innerValue = this.innerValue,
          disabled = this.disabled,
          clearDisabled = this.clearDisabled,
          isMultipleOrTags = this.isMultipleOrTags,
          optionMap = this.optionMap,
          setInnerValue = this.setInnerValue,
          maybeFocus = this.maybeFocus;
      var item = optionMap[name] || {};

      if (disabled || !!item.disabled && !clearDisabled) {
        return;
      }

      var values = innerValue.filter(function (v) {
        return String(v) !== String(name);
      });

      if (isMultipleOrTags) {
        this.$emit('deselect', name, buildOptionOriginNode(name, optionMap));
      }

      setInnerValue(values);
      maybeFocus();
    },
    onMenuDeselect: function onMenuDeselect(_ref3) {
      var name = _ref3.name;
      var removeSelected = this.removeSelected,
          clearSearchInputValue = this.clearSearchInputValue,
          autoClearSearchValue = this.autoClearSearchValue;
      removeSelected(name);

      if (autoClearSearchValue) {
        clearSearchInputValue(false);
      }
    },
    onClear: function onClear(e) {
      var _this2 = this;

      e.stopPropagation();
      var isMultipleOrTags = this.isMultipleOrTags,
          clearDisabled = this.clearDisabled,
          getSelectionValue = this.getSelectionValue,
          setInnerValue = this.setInnerValue,
          clearSearchInputValue = this.clearSearchInputValue,
          setInnerVisible = this.setInnerVisible,
          maybeFocus = this.maybeFocus,
          disabled = this.disabled;

      if (disabled) {
        return;
      }

      var values = [];

      if (isMultipleOrTags && !clearDisabled) {
        values = getSelectionValue().filter(function (v) {
          return !!v.disabled;
        }).map(function (v) {
          return v.value;
        });
      }

      setInnerValue(values);
      setInnerVisible(false);
      setTimeout(function () {
        clearSearchInputValue();

        _this2.$emit('clear');
      }, 100);
      maybeFocus();
    },
    onSelectorBlur: function onSelectorBlur() {
      var disabled = this.disabled,
          isTags = this.isTags,
          searchInputValue = this.searchInputValue,
          innerValue = this.innerValue,
          setSearchInputValue = this.setSearchInputValue,
          setInnerValue = this.setInnerValue;

      if (disabled) {
        return;
      }

      if (searchInputValue) {
        if (isTags) {
          if (innerValue.indexOf(searchInputValue) === -1) {
            setInnerValue([].concat(_toConsumableArray(innerValue), [searchInputValue]));
          }
        }

        setSearchInputValue('', false, false);
      }
    },
    onTokenSeparator: function onTokenSeparator(value) {
      var tokenSeparatorProp = this.tokenSeparatorProp,
          tokenSeparators = this.tokenSeparators,
          isMultipleOrTags = this.isMultipleOrTags,
          isTags = this.isTags,
          innerValue = this.innerValue,
          optionMap = this.optionMap,
          setInnerValue = this.setInnerValue,
          setInnerVisible = this.setInnerVisible,
          setSearchInputValue = this.setSearchInputValue;
      this.searchInputValue = value;

      if (isMultipleOrTags) {
        var valueMap = optionMap;

        if (tokenSeparatorProp === 'label') {
          valueMap = getOptionLabelMap(optionMap);
        }

        var values = _toConsumableArray(innerValue);

        splitValueBySeparator(value, tokenSeparators).forEach(function (label) {
          var option = valueMap[label];

          if (option) {
            if (values.indexOf(option.value) === -1) {
              values.push(option.value);
            }
          } else if (isTags) {
            if (values.indexOf(label) === -1) {
              values.push(label);
            }
          }
        });
        setInnerValue(values);
        setInnerVisible(false);
        setSearchInputValue('', false, false);
      }
    },
    onScroll: function onScroll(e) {
      this.$emit('scroll', e);
    },

    /*
     * 数据结构格式化为标准格式
     * {
     *   value:'',
     *   label:'',
     *   content: '',
     *   selectionContent: '',
     *   originNode: {}
     * }
     */
    formatOptions: function formatOptions() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var renderLabel = arguments.length > 1 ? arguments[1] : undefined;
      var renderGroupLabel = arguments.length > 2 ? arguments[2] : undefined;
      var optionMap = arguments.length > 3 ? arguments[3] : undefined;
      var formatOptions = this.formatOptions,
          normalizeOptionLabelProp = this.normalizeOptionLabelProp;
      var nOptionMap = optionMap;
      return options.map(function (option) {
        var nOption = _objectSpread({}, option, {
          originNode: omit(option, 'labelNode')
        });

        if (isOptionGroup(option)) {
          nOption.content = isFunction(renderGroupLabel) ? renderGroupLabel(option) : option.label;
          nOption.children = formatOptions(nOption.children, renderLabel, renderGroupLabel, nOptionMap);
        } else {
          if (isEqual(option.labelNode, {}) || isEqual(option.labelNode, [])) {
            nOption.labelNode = undefined;
          }

          var labelNode = nOption.labelNode || (isFunction(renderLabel) ? renderLabel(option) : undefined);
          nOption.content = labelNode || option.label || option.value;
          var selectionContent = option.label || option.value;

          if (normalizeOptionLabelProp) {
            // vue 同一渲染树中,同一vnode有且只能出现一次,所以clone一个节点用于页面显示
            selectionContent = normalizeOptionLabelProp === 'children' ? cloneLabelNodes(labelNode) : option[normalizeOptionLabelProp] || '';
          }

          nOption.selectionContent = selectionContent;
          nOptionMap[nOption.value] = nOption;
        }

        return nOption;
      });
    },
    // 保持已选中值正常显示,所以需要在datasource变化时缓存数据
    cacheOldValues: function cacheOldValues() {
      var innerValue = this.innerValue,
          optionMap = this.optionMap,
          innerValueObj = this.innerValueObj;
      var values = isArray(innerValue) ? innerValue : [innerValue];
      this.innerValueObj = values.reduce(function (r, key) {
        var nr = r;
        var obj = optionMap[key] || innerValueObj[key];

        if (obj) {
          nr[key] = obj;
        }

        return nr;
      }, {});
    },
    getFormatOptionsAndOptionMap: function getFormatOptionsAndOptionMap(options) {
      var $scopedSlots = this.$scopedSlots,
          isCombobox = this.isCombobox,
          innerValue = this.innerValue,
          prevOptions = this.prevOptions,
          renderLabel = this.renderLabel,
          renderGroupLabel = this.renderGroupLabel,
          formatOptions = this.formatOptions,
          normalizeOptionLabelProp = this.normalizeOptionLabelProp,
          setSearchInputValue = this.setSearchInputValue,
          cacheOldValues = this.cacheOldValues;

      if (isEqual(prevOptions, options)) {
        return {
          optionMap: this.optionMap,
          fOptions: this.fOptions
        };
      }

      this.prevOptions = cloneDeepWith(options, function (value, name) {
        // `labelNode` 是 `VNode` 类型,没有clone必要, clone时反而会造成问题
        if (name === 'labelNode') {
          return value;
        }

        return undefined;
      });
      cacheOldValues();
      var renderLabelFn = $scopedSlots.renderLabel || renderLabel;
      var renderGroupLabelFn = $scopedSlots.renderGroupLabel || renderGroupLabel;
      var optionMap = {};
      var fOptions = formatOptions(options, renderLabelFn, renderGroupLabelFn, optionMap); // 设置combobox input框的值

      if (isCombobox) {
        var prevOriginNodes = getOptionOriginNode(this.optionMap);
        var currentOriginNodes = getOptionOriginNode(optionMap);

        if (!isEqual(prevOriginNodes, currentOriginNodes)) {
          setSearchInputValue(getComboboxValue(innerValue, optionMap, normalizeOptionLabelProp), false, false);
        }
      }

      return {
        optionMap: optionMap,
        fOptions: fOptions
      };
    },
    renderChildren: function renderChildren() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var shouldNotFound = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var extraParam = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
        line: 0,
        // 第一级所在位置
        rootGroupLine: 0,
        rootLineMapping: {},
        selected: {
          // 第一级位置
          groupLine: 0,
          // 选中行实际位置
          line: -1
        }
      };
      var h = this.$createElement;
      var renderChildren = this.renderChildren,
          normalizeNotFountContent = this.normalizeNotFountContent,
          innerValue = this.innerValue,
          disabled = this.disabled;
      var nExtraParam = extraParam;
      var ret = [];

      for (var i = 0, l = options.length; i < l; i += 1) {
        var option = options[i];

        if (!isUnRenderOption(option)) {
          nExtraParam.line += 1;

          if (level === 0) {
            nExtraParam.rootGroupLine = i;
            nExtraParam.rootLineMapping[i] = {
              realLine: nExtraParam.line,
              nodeCnt: 0
            };
          }

          nExtraParam.rootLineMapping[nExtraParam.rootGroupLine].nodeCnt += 1;

          if (isOptionGroup(option)) {
            var children = option.children,
                content = option.content;
            var attrs = omit(option, ['uid', 'label', 'children', 'content', 'originNode']);
            var groupNode = h(VMenuItemGroup, _mergeJSXProps([{}, {
              key: "group-".concat(nExtraParam.line),
              attrs: attrs
            }]), [h("template", {
              "slot": "title"
            }, [content]), renderChildren(children, false, level + 1, nExtraParam)]);
            ret.push(groupNode);
          } else {
            var props = {
              name: option.value || option.value === 0 ? option.value : 'NO_VALUE',
              label: option.label,
              disabled: option.disabled || disabled
            };

            var _attrs = omit(option, ['uid', 'value', 'label', 'disabled', 'labelNode', 'content', 'selectionContent', 'originNode']);

            if (nExtraParam.selected.line === -1 && innerValue.indexOf(option.value) > -1) {
              nExtraParam.selected.groupLine = nExtraParam.rootGroupLine;
              nExtraParam.selected.line = nExtraParam.line;
            }

            var menuItemAttrs = {
              key: option.value,
              props: props,
              attrs: _attrs
            };
            ret.push(h(VMenuItem, _mergeJSXProps2([{}, menuItemAttrs]), [option.content]));
          }
        }
      }

      if (shouldNotFound && ret.length === 0 && normalizeNotFountContent) {
        nExtraParam.line += 1;
        ret.push(h(VMenuItem, {
          "key": "NOT_FOUND",
          "attrs": {
            "name": "NOT_FOUND",
            "disabled": true
          }
        }, [normalizeNotFountContent]));
      }

      return ret;
    },
    renderTrigger: function renderTrigger() {
      var $scopedSlots = this.$scopedSlots,
          renderSelectionInput = this.renderSelectionInput,
          isMultipleOrTagsOrCombobox = this.isMultipleOrTagsOrCombobox,
          renderSingleTrigger = this.renderSingleTrigger,
          renderMultipleTrigger = this.renderMultipleTrigger;
      var renderSelectionInputFn = $scopedSlots.renderSelectionInput || renderSelectionInput;
      return isMultipleOrTagsOrCombobox ? renderMultipleTrigger() : renderSingleTrigger(renderSelectionInputFn);
    },
    renderPopup: function renderPopup(options) {
      var h = this.$createElement;
      var $slots = this.$slots,
          prefixCls = this.prefixCls,
          innerValue = this.innerValue,
          nLazy = this.nLazy,
          isTags = this.isTags,
          isMultipleOrTags = this.isMultipleOrTags,
          dropdownMenuStyle = this.dropdownMenuStyle,
          extraTopContent = this.extraTopContent,
          extraBottomContent = this.extraBottomContent,
          onMenuSelect = this.onMenuSelect,
          onMenuDeselect = this.onMenuDeselect,
          onScroll = this.onScroll,
          searchFilterOptions = this.searchFilterOptions,
          getTagsFilterOptions = this.getTagsFilterOptions,
          renderChildren = this.renderChildren;
      var props = {
        prefixCls: "".concat(prefixCls, "-dropdown-menu"),
        selectedKeys: innerValue,
        multiple: isMultipleOrTags,
        mode: 'vertical',
        hasTitleAttr: true
      };
      var on = isMultipleOrTags ? {
        select: onMenuSelect,
        deselect: onMenuDeselect
      } : {
        click: onMenuSelect
      };
      var filtedOptions = searchFilterOptions(options);

      if (isTags) {
        filtedOptions = getTagsFilterOptions(filtedOptions);
      }

      var extraParam = {
        line: 0,
        // 第一级所在位置
        rootGroupLine: 0,
        rootLineMapping: {},
        selected: {
          // 第一级位置
          groupLine: 0,
          // 选中行实际位置
          line: -1
        }
      };
      var children = renderChildren(filtedOptions, true, 0, extraParam);
      var realLine = extraParam.line,
          selected = extraParam.selected,
          rootLineMapping = extraParam.rootLineMapping;
      this.selectedPos = selected;
      this.rootLineMapping = rootLineMapping;

      var virtualProps = _objectSpread({}, nLazy, {
        size: nLazy.height,
        remain: nLazy.remain > realLine ? realLine : nLazy.remain,
        wclass: "".concat(prefixCls, "-dropdown-menu-virtual"),
        wstyle: dropdownMenuStyle,
        wtag: VMenu,
        wprops: props,
        wlisteners: on,
        variable: function variable(index) {
          var node = rootLineMapping[index];

          if (!node) {
            // return 0;
            // http://opensource.cnsuning.com/uxcool/lerna-uxcool/issues/306
            return nLazy.height;
          }

          return node.nodeCnt * nLazy.height;
        },
        onscroll: onScroll
      });

      if (!this.isVirtualInit) {
        virtualProps.start = selected.groupLine || 0;
        this.isVirtualInit = true;
      }

      var extraTopContentFn = $slots.extraTopContent ? function () {
        return $slots.extraTopContent;
      } : extraTopContent;
      var extraBottomContentFn = $slots.extraBottomContent ? function () {
        return $slots.extraBottomContent;
      } : extraBottomContent;
      return h("div", {
        "slot": "popup"
      }, [isFunction(extraTopContentFn) ? h("div", {
        "class": ["".concat(prefixCls, "-dropdown-extra"), "".concat(prefixCls, "-dropdown-extra-top")]
      }, [extraTopContentFn()]) : null, nLazy ? h(VirtualList, _mergeJSXProps3([{}, {
        props: virtualProps,
        ref: 'virtualListRef'
      }]), [children]) : h(VMenu, _mergeJSXProps4([{}, {
        style: dropdownMenuStyle,
        props: props,
        on: on,
        nativeOn: {
          scroll: onScroll
        },
        ref: 'menuRef'
      }]), [children]), isFunction(extraBottomContentFn) ? h("div", {
        "class": ["".concat(prefixCls, "-dropdown-extra"), "".concat(prefixCls, "-dropdown-extra-bottom")]
      }, [extraBottomContentFn()]) : null]);
    }
  },
  render: function render() {
    var h = arguments[0];
    var $slots = this.$slots,
        isMounted = this.isMounted,
        dataSource = this.dataSource,
        prefixCls = this.prefixCls,
        innerVisible = this.innerVisible,
        disabled = this.disabled,
        popupClasses = this.popupClasses,
        popupClass = this.popupClass,
        popupStyle = this.popupStyle,
        builtinPlacements = this.builtinPlacements,
        transition = this.transition,
        getContainer = this.getContainer,
        getPopupWidth = this.getPopupWidth,
        getFormatOptionsAndOptionMap = this.getFormatOptionsAndOptionMap,
        renderTrigger = this.renderTrigger,
        renderPopup = this.renderPopup,
        onPopupVisibleChange = this.onPopupVisibleChange;
    var options = dataSource;

    if (!options) {
      var slotDefault = $slots.default || [];
      options = buildOptionsFromSlot(slotDefault);
    }

    var popupWidth = null;

    if (isMounted) {
      popupWidth = getPopupWidth();
    }

    var triggerProps = {
      prefixCls: "".concat(prefixCls, "-dropdown"),
      visible: innerVisible,
      actions: disabled ? [] : ['click'],
      popupClass: [popupClasses, popupClass],
      popupStyle: _objectSpread({}, popupWidth, {}, popupStyle),
      builtinPlacements: builtinPlacements,
      popupPlacement: 'bottomLeft',
      popupTransitionName: transition,
      getPopupContainer: getContainer
    };
    var on = {
      'popup-visible-change': onPopupVisibleChange
    };

    var _getFormatOptionsAndO = getFormatOptionsAndOptionMap(options),
        fOptions = _getFormatOptionsAndO.fOptions,
        optionMap = _getFormatOptionsAndO.optionMap; // no reactive


    this.optionMap = optionMap;
    this.fOptions = fOptions;
    return h(Trigger, _mergeJSXProps5([{}, {
      props: triggerProps,
      on: on,
      ref: 'triggerRef'
    }]), [renderTrigger(), renderPopup(fOptions)]);
  }
};